import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-drag-drop",
  templateUrl: "./drag-drop.component.html",
  styleUrls: ["./drag-drop.component.scss"],
})
export class DragDropComponent implements OnInit {
  constructor() {}
  @Input() supportedFormats: String;
  @Input() multiple: Boolean = false;
  @Output() fileSelected = new EventEmitter();
  imageUrl: string | ArrayBuffer = null;

  ngOnInit() {}

  previewFile(file) {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        this.imageUrl = reader.result;
      };
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    if ($event && $event.length > 0) {
      this.fileSelected.emit($event);
      if ($event && $event.length === 1 && $event[0].type.includes("image")) {
        this.previewFile($event[0]);
      }
    }
  }

  fileBrowseHandler(files) {
    if (files && files.length > 0) {
      this.fileSelected.emit(files);
      if (files && files.length === 1 && files[0].type.includes("image")) {
        this.previewFile(files[0]);
      }
    }
  }
}
